<template>
  <div class="hello">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/termin-reservieren">Termin reservieren</router-link>
    </Breadcrumb>
    <div class="wrapper margin-bottom--80 margin-top--40">
      <Headline subline="Kompetente Vor-Ort-Beratung" headline="Online-Terminreservierung" />
      <div class="row">
        <div class="col-xs-12 col-md-8">
          <p>Wenn wir Ihnen hier nicht weiterhelfen können und um unnötige Wartezeiten zu vermeiden, bieten Ihnen die Bürgerbüros der Stadt Augsburg die Möglichkeit, hier online einen Termin innerhalb unserer Öffnungszeiten zu vereinbaren. Wählen Sie Ihr Bürgerbüro und füllen anschließend einfach das folgende Formular aus.
Auch Telefonisch können über die Rufnummer <a href="tel:+ 324-9999">324-9999</a> in der Zeit von <b>08:00</b> bis <b>12:30</b> Uhr Termine gebucht werden.</p>
        </div>
      </div>
      <div class="row margin-top--30">
        <div ref="card0" @click="openCard(0)" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 margin-top--20">
          <Card padding="25px 15px" class="authority">
            <div>
              <h3>Bürgerbüro Stadtmitte</h3>
              <p class="color-error">wenig verfügbare Termine</p>
            </div>
            <img src="../../assets/images/logo.svg" alt="">
          </Card>
        </div>
        <div ref="card1" @click="openCard(1)" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 margin-top--20">
          <Card padding="25px 15px" class="authority">
            <div>
              <h3>Bürgerbüro Kriegshaber</h3>
              <p class="color-success">Viele verfügbare Termine</p>
            </div>
            <img src="../../assets/images/logo.svg" alt="">
          </Card>
        </div>
        <div ref="card2" @click="openCard(2)" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 margin-top--20">
          <Card padding="25px 15px" class="authority">
            <div>
              <h3>Bürgerbüro Lechhausen</h3>
              <p class="color-info">Verfügbare Termine</p>
            </div>
            <img src="../../assets/images/logo.svg" alt="">
          </Card>
        </div>
        <div ref="card3" @click="openCard(3)" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 margin-top--20">
          <Card padding="25px 15px" class="authority">
            <div>
              <h3>Bürgerbüro Haunstetten</h3>
              <p class="color-success">Viele verfügbare Termine</p>
            </div>
            <img src="../../assets/images/logo.svg" alt="">
          </Card>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <transition name="tabs" mode="out-in">
            <Card v-for="tab in tabs" :key="tab" v-if="currentTab == tab" padding="35px" class="tab">
              <img :src="currentImg"  @click="changeTab">
              <div class="arrow" :style="{left: left}"></div>
            </Card>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../components/Icon/Icon';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Card from '../../components/Card/Card';
import Headline from '../../components/Headline/Headline';
import Button from '../../components/Button/Button';

import tab0 from '../../assets/images/tab0.svg';
import tab1 from '../../assets/images/tab1.svg';
import tab2 from '../../assets/images/tab2.svg';
import tab3 from '../../assets/images/tab3.svg';
import tab4 from '../../assets/images/tab4.svg';

export default {
  name: 'Appointment',
  components: {
    Icon,
    Breadcrumb,
    Card,
    Headline,
    Button,
  },
  data() {
    return {
      currentTab: -1,
      tabs: [0,1,2,3,4],
      left: 15,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
    currentImg() {
      if(this.currentTab == 0) {
        return tab0;
      } else if(this.currentTab == 1) {
        return tab1;
      } else if(this.currentTab == 2) {
        return tab2;
      } else if(this.currentTab == 3) {
        return tab3;
      } else if(this.currentTab == 4) {
        return tab4;
      }
    }
  },
  methods: {
    openCard(id) {
      this.currentTab = 0;
      this.left = 25*(id+1) + '%';
      this.$refs.card0.classList.remove('disabled');
      this.$refs.card1.classList.remove('disabled');
      this.$refs.card2.classList.remove('disabled');
      this.$refs.card3.classList.remove('disabled');
      if(id != 0) {
        this.$refs.card0.classList.add('disabled');
      }
      if(id != 1) {
        this.$refs.card1.classList.add('disabled');
      }
      if(id != 2) {
        this.$refs.card2.classList.add('disabled');
      }
      if(id != 3) {
        this.$refs.card3.classList.add('disabled');
      }
    },
    changeTab() {
      if(this.currentTab < 4) {
        this.currentTab++;
        console.log(this.currentTab);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Appointment.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Appointment/Appointment.vue